/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumncredits3Inputs */

const en_sharereviewcolumncredits3 = /** @type {(inputs: Sharereviewcolumncredits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const de_sharereviewcolumncredits3 = /** @type {(inputs: Sharereviewcolumncredits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Sharereviewcolumncredits3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumncredits3 = /** @type {((inputs?: Sharereviewcolumncredits3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumncredits3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumncredits3(inputs)
	return de_sharereviewcolumncredits3(inputs)
});
export { sharereviewcolumncredits3 as "shareReviewColumnCredits" }